module.exports = __webpack_public_path__ + "img/icon_klip_small_blue.115bdce4.svg";